var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paywall"},[_vm._m(0),_c('button',{staticClass:"btn-orange",on:{"click":function($event){return _vm.$emit('done')}}},[_vm._v("AVANÇAR")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paywall-inner"},[_c('p',{staticClass:"label"},[_vm._v("Pay wall")])])
}]

export { render, staticRenderFns }